import React, { Fragment } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import { Icon24Dismiss } from '@vkontakte/icons';
import clsx from 'clsx';
import Text from '../Text';
import Button from '../Button';

interface BottomSheetProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  text?: string;
  customIcon?: React.ReactNode;
  actions?: {
    label: string;
    onPress: () => void;
    type?: 'primary' | 'secondary';
  }[];
}

export default function BottomSheet({
  isOpen,
  onClose,
  title,
  text,
  customIcon,
  actions,
}: BottomSheetProps) {
  return (
    // @ts-ignore - TypeScript compatibility issue with React 18 and HeadlessUI
    <Transition.Root show={isOpen} as={Fragment as any}>
      {/* @ts-ignore - TypeScript compatibility issue with React 18 and HeadlessUI */}
      <Dialog as="div" className="relative z-[100]" onClose={onClose}>
        {/* @ts-ignore - TypeScript compatibility issue with React 18 and HeadlessUI */}
        <Transition.Child
          as={Fragment as any}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          {/* @ts-ignore - TypeScript compatibility issue with React 18 and HeadlessUI */}
          <div className="fixed inset-0 bg-black/60 backdrop-blur-sm transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 overflow-y-auto">
          <div className="flex min-h-full items-end justify-center text-center sm:items-center">
            {/* @ts-ignore - TypeScript compatibility issue with React 18 and HeadlessUI */}
            <Transition.Child
              as={Fragment as any}
              enter="ease-out duration-300 transform"
              enterFrom="translate-y-full sm:translate-y-0 sm:scale-95"
              enterTo="translate-y-0 sm:scale-100"
              leave="ease-in duration-200 transform"
              leaveFrom="translate-y-0 sm:scale-100"
              leaveTo="translate-y-full sm:translate-y-0 sm:scale-95"
            >
              {/* @ts-ignore - TypeScript compatibility issue with React 18 and HeadlessUI */}
              <Dialog.Panel className="relative w-full transform overflow-hidden rounded-t-[32px] bg-sharp-darkglass px-4 pb-6 pt-6 text-left shadow-xl transition-all sm:my-8 sm:max-w-lg sm:rounded-3xl sm:p-10 sm:px-6 sm:pb-8 sm:pt-10">
                {/* @ts-ignore - TypeScript compatibility issue with React 18 types */}
                <div className="absolute right-4 top-4 sm:right-6 sm:top-6">
                  {/* @ts-ignore - TypeScript compatibility issue with React 18 types */}
                  <button
                    type="button"
                    className="rounded-full bg-white/5 p-2 text-white/40 hover:text-white transition-colors"
                    onClick={onClose}
                  >
                    <Icon24Dismiss className="h-4 w-4 sm:h-5 sm:w-5" />
                  </button>
                </div>

                {/* @ts-ignore - TypeScript compatibility issue with React 18 types */}
                <div className="flex flex-col items-center text-center">
                  {customIcon && (
                    <div className="mb-4 flex h-16 w-16 sm:h-20 sm:w-20 items-center justify-center rounded-full bg-white/5 sm:mb-6">
                      {customIcon}
                    </div>
                  )}
                  
                  {/* @ts-ignore - TypeScript compatibility issue with React 18 and HeadlessUI */}
                  <Dialog.Title as="h3" className="text-lg sm:text-2xl text-white mb-2">
                    {title}
                  </Dialog.Title>
                  
                  {text && (
                    <>
                      {/* @ts-ignore - TypeScript compatibility issue with React 18 types */}
                      <Text className="text-secondary text-sm sm:text-base leading-relaxed mb-6 px-2 sm:mb-8 sm:px-4">
                        {text}
                      </Text>
                    </>
                  )}

                  <div className="flex w-full flex-col gap-2 sm:gap-3 mt-4">
                    {actions?.map((action, index) => (
                      <>
                        {/* @ts-ignore - TypeScript compatibility issue with React 18 types */}
                        <Button
                        key={index}
                        onClick={action.onPress}
                        size="md"
                        className={clsx(
                          "w-full h-12 sm:h-14 rounded-full transition-all active:scale-95 text-sm sm:text-base",
                          action.type === 'primary' 
                            ? "bg-gradient-to-r from-purple to-pink text-white shadow-lg" 
                            : "bg-white/10 text-white hover:bg-white/20"
                        )}
                      >
                        {action.label}
                      </Button>
                      </>
                    ))}
                  </div>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}
